import { useMediaQuery } from '@mui/material'
import { BREAKPOINT_VALUES } from '@/styles'

const useDeviceType = () => {
  const isMobile = useMediaQuery(`(max-width: ${BREAKPOINT_VALUES.MD}px)`)

  const isTablet = useMediaQuery(
    `(min-width: ${BREAKPOINT_VALUES.MD + 1}px) and (max-width: ${BREAKPOINT_VALUES.LG}px)`,
  )

  const isDesktop = useMediaQuery(`(min-width: ${BREAKPOINT_VALUES.LG + 1}px)`)

  return {
    isMobile,
    isDesktop,
    isTablet,
  }
}
export default useDeviceType
